<template>
  <div class="preloader">
    <div class="preloader__inner">
      <span class="preloader__img">
        <svg-icon
          name="solid/spinner"
          class="tw:h-10 tw:w-10 tw:animate-spin"
        ></svg-icon>
      </span>
    </div>
  </div>
</template>

<style lang="scss">
.preloader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.71);
  overflow: hidden;
  &__inner {
    display: block;
    max-width: 500px;
  }

  &__img {
    svg {
      width: 40px !important;
      height: 40px !important;
      color: white;
      animation: lds-dual-ring 1s linear infinite;
    }
  }
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
